import {NumberUDF} from "./UDFs/NumberUDF";
import {StringUDF} from "./UDFs/StringUDF";
import {BooleanUDF} from "./UDFs/BooleanUDF";

export class EncodeTagConfiguration {

  AllowKeyboardInputForAssociations: BooleanUDF;
  AutoSave: BooleanUDF;
  AutoSaveTimer: NumberUDF;
  CompanyPrefixLenght: NumberUDF;
  DefaultEncodeZone: StringUDF;
  DefaultProductUPCUDF:StringUDF;
  EncodeFilterValue: StringUDF;
  EncodeZoneUDF: StringUDF;
  FirstBarcodeUDF: StringUDF;
  FirstFieldAutoPad: NumberUDF;
  FirstFieldLabel: StringUDF;
  FirstFieldReaderType: StringUDF;
  FirstFieldValidation: StringUDF;
  FirstThingTypeCode: StringUDF;
  HeaderValue: StringUDF;
  ItemUPCUDF: StringUDF;
  Partition: StringUDF;
  OriginalValueUDF:StringUDF;
  SecondBarcodeUDF: StringUDF;
  SecondFieldAutoPad: NumberUDF;
  SecondFieldLabel: StringUDF;
  SecondFieldReaderType: StringUDF;
  SecondFieldValidation: StringUDF;
  SecondThingTypeCode: StringUDF;
  ShowZonePickList: BooleanUDF;
  ThingTypeCodeToSync: StringUDF;
  UseTID: BooleanUDF;
  ValueExpression: StringUDF;
  WritePassword: StringUDF;
  EncodeSchema: StringUDF;
  ConvertSerialToHex: BooleanUDF;
  EncodeSerialThingTypeCode: StringUDF;

  get(): any {
    return {
      AllowKeyboardInputForAssociations: this.AllowKeyboardInputForAssociations.value,
      AutoSave:this.AutoSave.value,
      AutoSaveTimer:this.AutoSaveTimer.value,
      CompanyPrefixLenght:this.CompanyPrefixLenght.value,
      DefaultEncodeZone:this.DefaultEncodeZone.value,
      DefaultProductUPCUDF:this.DefaultProductUPCUDF.value,
      EncodeFilterValue:this.EncodeFilterValue.value,
      EncodeZoneUDF:this.EncodeZoneUDF.value,
      FirstBarcodeUDF:this.FirstBarcodeUDF,
      FirstFieldAutoPad:this.FirstFieldAutoPad.value,
      FirstFieldLabel:this.FirstFieldLabel.value,
      FirstFieldReaderType:this.FirstFieldReaderType.value,
      FirstFieldValidation:this.FirstFieldValidation.value,
      FirstThingTypeCode:this.FirstThingTypeCode.value,
      HeaderValue:this.HeaderValue.value,
      ItemUPCUDF:this.ItemUPCUDF.value,
      OriginalValueUDF:this.OriginalValueUDF.value,
      Partition:this.Partition.value,
      SecondBarcodeUDF:this.SecondBarcodeUDF.value,
      SecondFieldAutoPad:this.SecondFieldAutoPad.value,
      SecondFieldLabel:this.SecondFieldLabel.value,
      SecondFieldReaderType:this.SecondFieldReaderType.value,
      SecondFieldValidation:this.SecondFieldValidation.value,
      SecondThingTypeCode:this.SecondThingTypeCode.value,
      ShowZonePickList:this.ShowZonePickList.value,
      ThingTypeCodeToSync:this.ThingTypeCodeToSync.value,
      UseTID:this.UseTID.value,
      ValueExpression:this.ValueExpression.value,
      WritePassword:this.WritePassword.value,
      EncodeSchema: this.EncodeSchema.value,
      ConvertSerialToHex: this.ConvertSerialToHex.value,
      EncodeSerialThingTypeCode:  this.EncodeSerialThingTypeCode.value
    }
  }
}








// WEBPACK FOOTER //
// ./src/models/encodeTag.config.ts